// src/Camera.js
import React, {useEffect, useState, useRef} from 'react';
import {useLocation,useNavigate,Link,useParams} from 'react-router-dom'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import html2canvas from 'html2canvas';
import { BiSolidLeftArrow, BiSolidRightArrow } from 'react-icons/bi';
import {CgSoftwareDownload} from 'react-icons/cg';

import '../ResultTemplate.css';
import { sendAnalyticsData } from '../utilities/analytics';

import jsonData from '../template.json'

// const resultAPI = process.env.REACT_APP_RESULT_TEMPLATE;
const resultAPI = jsonData;
const updateAPI = 'https://wardah-colourstory.com/wsapi/users/update_color';

const PageResultTemplate = () => {
  const [result, setResult] = useState({});
  const [userName, setUserName] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [userPhone, setUserPhone] = useState('');
  const [subSeason, setSubSeason] = useState('');
  const [subSeasonAccuracy, setSubSeasonAccuracy] = useState('0%');
  const [subSeasonAlt, setSubSeasonAlt] = useState('0%');
  const [subSeasonAccuracyAlt, setSubSeasonAccuracyAlt] = useState('0%');
  const [complexion, setComplexion] = useState('');
  const [complexionName, setComplexionName] = useState('');
  const [complexionCode, setComplexionCode] = useState('');
  const [shareTemplate, setShareTemplate] = useState('autumn');
  const [skintoneColor, setSkintoneColor] = useState('#F3C4BF');
  const [complexionProducts, setComplexionProducts] = useState([]);
  // const [complexionCombinedProducts, setComplexionCombinedProducts] = useState([]);
  const [shareComplexionProducts, setShareComplexionProducts] = useState('');
  const [deviceType, setDeviceType] = useState('desktop');

  const { type } = useParams();
  const navigate = useNavigate()
  const location = useLocation();

  const captureMobileRef = useRef(null);
  const canvasRef = useRef(null);
  const divElement = captureMobileRef.current;

  // const urlVto = 'https://pixielab.s3.ap-southeast-3.amazonaws.com/wardah-vto-external/index.html';
  const urlVto = process.env.REACT_APP_VTO_URL || 'https://wardah-colourintelligence.com/vto-colourverse';

  const mobileAndTabletCheck = () => {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);

    if(check){
      setDeviceType('mobile');
    }else{
      setDeviceType('desktop');
    }
  };

  const SlickButton = ({currentSlide, slideCount, children, ...props}) => (
    <a {...props}>{children}</a>
  );
  
  const arrowSlider = {
    nextArrow: 
      <SlickButton className="slick-arrow slick-next">
          <BiSolidRightArrow/>
      </SlickButton>,
    prevArrow: 
      <SlickButton className="slick-arrow slick-prev">
          <BiSolidLeftArrow/>
      </SlickButton>
  }
  
  const settingsLipsSection = {
    dots: false,
    infinite: false,
    accessibility: true,
    arrows: true,
    speed: 800,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    ...arrowSlider
  };
  
  // Helper function to chunk array into groups of size n
  function chunkArray(array, size) {
    return array.reduce((acc, _, i) => (i % size ? acc : [...acc, array.slice(i, i + size)]), []);
  }
  
  
  const RenderProductsLipsMobile = ({data = []}) => {
    
    const settingsProduct = {
      dots: false,
      infinite: false,
      accessibility: true,
      arrows: false,
      speed: 800,
      autoplaySpeed: 3000,
      slidesToShow: 3,
      ...arrowSlider
    };
  
    if (data.length !== 0) {
      return (
        <>
          <div className='list-product-lips pb-4' key={JSON.stringify(data)}>
            {data.map((category, index) => {
              return (
                <div className='list-product pb-2 pb-md-2' key={index}>
                  <div className="title-category-image mx-auto text-center">
                    <img src={category.categoryImage+'?withheaders='} alt=''/>
                  </div>
                  <div className='product-content'>
                    <div className='side-image'>
                      {
                      index === 0 ?
                      <>
                        <img src='/assets/images/products/image-glossicle.png' alt='' />
                      </>
                      :
                      index === 1 ?
                      <>
                        <img src='/assets/images/products/image-airbrush.png' alt='' />
                      </>
                      :
                      index === 2 ?
                      <>
                        <img src='/assets/images/products/image-lip-cream.png' alt='' />
                      </>
                      :
                      index === 3 ?
                      <>
                        <img src='/assets/images/products/image-lip-glasting.png' alt='' />
                      </>
                      :
                      index === 4 ?
                      <>
                        <img src='/assets/images/products/image-moist-dew.png' alt='' />
                      </>
                      :
                      index === 5 ?
                      <>
                        <img src='/assets/images/products/image-lip-mousse.png' alt='' />
                      </>
                      :
                      index === 6 ?
                      <>
                        <img src='/assets/images/products/image-lip-paint.png' alt='' />
                      </>
                      :
                      index === 7 ?
                      <>
                        <img src='/assets/images/products/image-lipstick.png' alt='' />
                      </>
                      :
                      null
                      }
                    </div>
                    
                    <Slider key={index} className='product-slider' {...settingsProduct}>
                      {category.item.map((item, itemIndex) => (
                        <div key={itemIndex} className='product-slide'>
                          <a className='image-product' href={`${urlVto}?name=${userName}&email=${userEmail}&phone=${userPhone}&season=${subSeason}&season_accuracy=${subSeasonAccuracy}&season_alt=${subSeasonAlt}&season_alt_accuracy=${subSeasonAccuracyAlt}&complexion=${getShade() ? getShade().replace('#', '%23') : ''}&product=lipstick&color=${item.color ? item.color.replace('#', '%23') : ''}`} onClick={()=>{sendAnalyticsData('Click',`Product ${item.link}`)}}>
                            {item.image ?
                              <img src={item.image+'?withheaders='} alt='' />
                              :
                              <span className='bg-dark'></span>
                            }
                          </a>
                        </div>
                      ))}
                      <div className='product-slide'>
                        <a className='image-product' style={{opacity: '0'}}>
                          <img src={null} alt='' />
                        </a>
                      </div>
                    </Slider>
                  </div>
                </div>
              )
            })}
          </div>
        </>
      );
    }
  
    return null;
  }
  
  const RenderProductsLips = ({ data = [] }) => {
    const settingsProduct = {
      dots: false,
      infinite: false,
      accessibility: true,
      arrows: true,
      speed: 800,
      autoplaySpeed: 3000,
      slidesToShow: 3,
      ...arrowSlider
    };
    if (data.length !== 0) {
  
      console.log(data.length)
      var groupedData = data;
  
      if(data.length > 4){
        groupedData = chunkArray(data, 4);
        return (
          <Slider className='slider-lips-section product-slider' {...settingsLipsSection}>
            {groupedData.map((group, groupIndex) => (
              <div className="wrapper-section-lips" key={groupIndex}>
                {group.map((category, index) => (
                  <div className='list-product pb-2 pb-md-2' key={index}>
                    <div className="title-category-image text-center">
                      <img src={category.categoryImage+'?withheaders='} alt='' />
                    </div>
                    <Slider key={index} className='product-slider' {...settingsProduct}>
                      {category.item.map((item, itemIndex) => (
                        <div key={itemIndex} className='product-slide'>
                          <a className='image-product' href={`${urlVto}?name=${userName}&email=${userEmail}&phone=${userPhone}&season=${subSeason}&season_accuracy=${subSeasonAccuracy}&season_alt=${subSeasonAlt}&season_alt_accuracy=${subSeasonAccuracyAlt}&complexion=${getShade() ? getShade().replace('#', '%23') : ''}&product=lipstick&color=${item.color ? item.color.replace('#', '%23') : ''}`} onClick={() => { sendAnalyticsData('Click', `Product ${item.link}`) }}>
                            {item.image ?
                              <img src={item.image+'?withheaders='} alt='' />
                              :
                              <span className='bg-dark'></span>
                            }
                          </a>
                        </div>
                      ))}
                    </Slider>
                  </div>
                ))}
              </div>
            ))}
          </Slider>
        );
      }else{
        return(
          groupedData.map((group, groupIndex) => (
            <div className='list-product pb-4 pb-md-2' key={groupIndex}>
              <div className="title-category-image text-center">
                <img src={group.categoryImage+'?withheaders='} alt='' />
              </div>
              <Slider key={groupIndex} className='product-slider' {...settingsProduct}>
                {group.item.map((item, itemIndex) => (
                  <div key={itemIndex} className='product-slide'>
                    <a className='image-product' href={`${urlVto}?name=${userName}&email=${userEmail}&phone=${userPhone}&season=${subSeason}&season_accuracy=${subSeasonAccuracy}&season_alt=${subSeasonAlt}&season_alt_accuracy=${subSeasonAccuracyAlt}&complexion=${getShade() ? getShade().replace('#', '%23') : ''}&product=lipstick&color=${item.color ? item.color.replace('#', '%23') : ''}`} onClick={() => { sendAnalyticsData('Click', `Product ${item.link}`) }}>
                      {item.image ?
                        <img src={item.image+'?withheaders='} alt='' />
                        :
                        <span className='bg-dark'></span>
                      }
                    </a>
                  </div>
                ))}
              </Slider>
            </div>
          ))
        )
      }
    }
  
    return null;
  }
  
  const RenderProductsBlushOn = ({data = []}) => {
    const settingsProduct = {
      dots: false,
      infinite: false,
      accessibility: false,
      arrows: true,
      speed: 800,
      autoplaySpeed: 3000,
      slidesToShow: 3,
      ...arrowSlider
    };
  
    if (data.length !== 0) {
      return (
        <Slider key={JSON.stringify(data)} className='product-slider' {...settingsProduct}>
          {data.map((item, itemIndex) => (
            <div key={itemIndex} className='product-slide'>
              <a className='image-product' href={`${urlVto}?name=${userName}&email=${userEmail}&phone=${userPhone}&season=${subSeason}&season_accuracy=${subSeasonAccuracy}&season_alt=${subSeasonAlt}&season_alt_accuracy=${subSeasonAccuracyAlt}&complexion=${getShade() ? getShade().replace('#', '%23') : ''}&product=blush&color=${item.color ? item.color.replace('#', '%23') : ''}`} onClick={()=>{sendAnalyticsData('Click',`Product ${item.link}`)}}>
                {item.image ?
                  <img src={item.image+'?withheaders='} alt='' />
                  :
                  <span className='bg-dark'></span>
                }
              </a>
              <p><span className='d-block' style={{marginBottom: '2px'}}>{item.category}</span> <strong>{item.code}</strong> {item.name}</p>
            </div>
          ))}
        </Slider>
      );
    }
  
    return null;
  };
  
  const RenderProductsEyes = ({data = [], isMobile}) => {
    const settingsProduct = {
      dots: false,
      infinite: false,
      accessibility: false,
      arrows: true,
      adaptiveHeight: true,
      speed: 800,
      autoplaySpeed: 3000,
      slidesToShow: 1,
      ...arrowSlider
    };
  
    if (data.length !== 0) {
      if(isMobile){
        return(
          <>
            {data.map((item, itemIndex) => (
              <div key={itemIndex} className='product-eye pb-4 pb-md-2'>
                <div className="title-category-image d-table mb-3 mx-auto">
                  <img src={item.categoryImage+'?withheaders='} alt=''/>
                </div>
                {item.item.map((i, index) => (
                  <div key={index} onClick={()=>{sendAnalyticsData('Click',`Product ${i.link}`)}} className='image-product d-flex mb-2' style={{aspectRatio: 'unset'}}>
                    {i.colors && !i.image?
                      i.colors.map(function(color) {
                        return <a className='palette-grid-item' key={color}
                        href={`${urlVto}?name=${userName}&email=${userEmail}&phone=${userPhone}&season=${subSeason}&season_accuracy=${subSeasonAccuracy}&season_alt=${subSeasonAlt}&season_alt_accuracy=${subSeasonAccuracyAlt}&complexion=${getShade() ? getShade().replace('#', '%23') : ''}&product=eyeshadow&color=${color ? color.replace('#', '%23') : ''}`} style={{'backgroundColor': color}}></a>
                      })
                      :
                      null
                    }
                    {
                      i.image ?
                      <div className="wrapper-eyeshadow-glitter">
                        <img src={i.image+'?withheaders='} alt='' />
                        {i.colors.map(function(color) {
                          return <a className='palette-grid-item' key={color}
                          href={`${urlVto}?name=${userName}&email=${userEmail}&phone=${userPhone}&season=${subSeason}&season_accuracy=${subSeasonAccuracy}&season_alt=${subSeasonAlt}&season_alt_accuracy=${subSeasonAccuracyAlt}&complexion=${getShade() ? getShade().replace('#', '%23') : ''}&product=eyeshadow&color=${color ? color.replace('#', '%23') : ''}`} style={{'backgroundColor': color}} data-eyeshadow-type={color}></a>
                        }
                        )}
                      </div>
                      :
                      null
                    }
                  </div>
                ))}
              </div>
            ))}
          </>
        )
      }else{
        return (
          <Slider key={JSON.stringify(data)} className='product-slider' {...settingsProduct}>
            {data.map((item, itemIndex) => (
              <div key={itemIndex} className='product-slide'>
                <div className="title-category-image d-table mb-3 mx-auto">
                  <img src={item.categoryImage+'?withheaders='} alt=''/>
                </div>
                {item.item.map((i, index) => (
                  <div onClick={()=>{sendAnalyticsData('Click',`Product ${i.link}`)}} key={index} className='image-product d-flex mb-2' style={{aspectRatio: 'unset'}}>
                    {i.colors && !i.image?
                      i.colors.map(function(color) {
                        return <a className='palette-grid-item'
                        href={`${urlVto}?name=${userName}&email=${userEmail}&phone=${userPhone}&season=${subSeason}&season_accuracy=${subSeasonAccuracy}&season_alt=${subSeasonAlt}&season_alt_accuracy=${subSeasonAccuracyAlt}&complexion=${getShade() ? getShade().replace('#', '%23') : ''}&product=eyeshadow&color=${color ? color.replace('#', '%23') : ''}`} style={{'backgroundColor': color}}></a>
                      })
                      :
                      null
                    }
                    {
                      i.image ?
                      <div className="wrapper-eyeshadow-glitter">
                        <img src={i.image+'?withheaders='} alt='' />
                        {i.colors.map(function(color) {
                          return <a className='palette-grid-item'
                          href={`${urlVto}?name=${userName}&email=${userEmail}&phone=${userPhone}&season=${subSeason}&season_accuracy=${subSeasonAccuracy}&season_alt=${subSeasonAlt}&season_alt_accuracy=${subSeasonAccuracyAlt}&complexion=${getShade() ? getShade().replace('#', '%23') : ''}&product=eyeshadow&color=${color ? color.replace('#', '%23') : ''}`} style={{'backgroundColor': color}} data-eyeshadow-type={color}></a>
                        }
                        )}
                      </div>
                      :
                      null
                    }
                  </div>
                ))}
              </div>
            ))}
          </Slider>
        );
      }
    }
  
    return null;
  };

  const RenderProductComplexion = ({ data = [], slidesToShow }) => {
    const settingsProduct = {
      dots: false,
      infinite: false,
      accessibility: false,
      arrows: true,
      adaptiveHeight: true,
      speed: 800,
      autoplaySpeed: 3000,
      slidesToShow: slidesToShow,
      ...arrowSlider,
    };
  
    if (data.length !== 0) {
      return (
        <Slider key={JSON.stringify(data)} className="product-slider" {...settingsProduct}>
          {data.map((complexionEl) => {
            const items = Array.isArray(complexionEl.item)
              ? complexionEl.item.concat(complexionEl.item)
              : [];
            return items.map((item, index) => (
              <div key={`${item.color || index}`} className="product-slide">
                <a
                  className="image-product d-flex mb-2"
                  href={`${urlVto}?name=${userName}&email=${userEmail}&phone=${userPhone}&season=${subSeason}&season_accuracy=${subSeasonAccuracy}&season_alt=${subSeasonAlt}&season_alt_accuracy=${subSeasonAccuracyAlt}&complexion=${getShade() ? getShade().replace('#', '%23') : ''}&product=foundation&color=${item.color ? item.color.replace('#', '%23') : ''}`}
                  onClick={() => {
                    sendAnalyticsData('Click', `Product ${item.link}`);
                  }}
                >
                  {item.image ? (
                    <img src={`${item.image}?withheaders=`} style={{ width: '92%' }} alt="" />
                  ) : (
                    <span className="bg-dark ratio-1x1"></span>
                  )}
                </a>
              </div>
            ));
          })}
        </Slider>
      );
    }
  
    return null;
  };
  
  const RenderProductComplexionMobile = ({data = []}) => {
    if (data.length !== 0) {
      const filteredItems = data.filter(item => item.type === 'complexion' && item.category === 'cushion');
      return (
        <div 
          key={JSON.stringify(data)} 
          className="product-slider mb-4"  
          style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', alignItems: 'end'}}
        >
          {data.map((item, itemIndex) => {
            if (item.type === 'complexion' && item.category === 'cushion') {
              return (
                <>
                  <a
                    key={itemIndex}
                    className="item-big image-product d-flex mb-4" style={{'padding': '0 10px'}}
                    href={`${urlVto}?name=${userName}&email=${userEmail}&phone=${userPhone}&season=${subSeason}&season_accuracy=${subSeasonAccuracy}&season_alt=${subSeasonAlt}&season_alt_accuracy=${subSeasonAccuracyAlt}&complexion=${getShade() ? getShade().replace('#', '%23') : ''}&product=foundation&color=${item.color ? 
                      item.color.replace('#', '%23') : ''}`}
                    onClick={() => sendAnalyticsData('Click', `Product ${item.link}`)}
                  >
                    <img className='click-tips' src='/images/click-tips.png'/>
                    {item.image ? (
                      <img src={`${item.image}?withheaders=`} width="100%" alt="" />
                    ) : (
                      <span className="bg-dark ratio-1x1"></span>
                    )}
                    
                    {itemIndex === 0 ? (
                      <p className='desc' style={{backgroundColor: '#A5B4A1'}} dangerouslySetInnerHTML={{ __html: 'More cover & soft matte finish<br/>18H Longlasting & SPF 50 PA +++<br/>Infused with CICA & Nano Hyaluron' }} />
                    ) : itemIndex === 1 ? (
                      <p className='desc' dangerouslySetInnerHTML={{ __html: 'Smooth glow finish<br/>12H Longlasting & SPF 40 PA +++<br/>Infused with CICA & Hydra Beta Glucan' }} />
                    ) : null}
                  </a>
                  {filteredItems.length === 1 ? <div className='w-100'></div>: null}
                </>
              );
            }

            if (item.type === 'complexion') {
              return (
                <a
                  key={itemIndex}
                  className="image-product d-flex" style={{'width': '33%', 'padding': '0 10px'}}
                  href={`${urlVto}?name=${userName}&email=${userEmail}&phone=${userPhone}&season=${subSeason}&season_accuracy=${subSeasonAccuracy}&season_alt=${subSeasonAlt}&season_alt_accuracy=${subSeasonAccuracyAlt}&complexion=${getShade() ? getShade().replace('#', '%23') : ''}&product=foundation&color=${item.color ? 
                    item.color.replace('#', '%23') : ''}`}
                  onClick={() => sendAnalyticsData('Click', `Product ${item.link}`)}
                >
                  {item.image ? (
                    <img src={`${item.image}?withheaders=`} width="100%" alt="" />
                  ) : (
                    <span className="bg-dark ratio-1x1"></span>
                  )}
                </a>
              );
            }
            return null; // Explicitly return null for items not matching the condition
          })}
        </div>
      );
    }
  
    return null;
  };
  
  const RenderProductComplexionLightening = ({data = []}) => {
    if (data.length !== 0) {
      return (
        <div 
        className="product-slider mb-4"  
        style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', alignItems: 'end' }}
        >
          {data.map((item, itemIndex) => {
            if (item.type === 'lightening') {
              return (
            <a key={itemIndex} className='image-product' style={{'width': '33%', 'padding': '0 10px'}} href={`${urlVto}?name=${userName}&email=${userEmail}&phone=${userPhone}&season=${subSeason}&season_accuracy=${subSeasonAccuracy}&season_alt=${subSeasonAlt}&season_alt_accuracy=${subSeasonAccuracyAlt}&complexion=${getShade() ? getShade().replace('#', '%23') : ''}&product=foundation&color=${item.color ? item.color.replace('#', '%23') : ''}`} onClick={()=>{sendAnalyticsData('Click',`Product ${item.link}`)}}>
              {item.image ?
                <img src={item.image+'?withheaders='} width="100%" alt='' />
                :
                <span className='bg-dark ratio-1x1'></span>
              }
            </a>
              );
            }
            return null; // Explicitly return null for items not matching the condition
          })}
        </div>
      );
    }
  
    return null;
  };
  
  const RenderPaletteGrid = ({data = [], slidesToShow, isMobile}) => {
    const settingsPaletteSlider = {
      dots: false,
      infinite: false,
      accessibility: true,
      arrows: true,
      speed: 800,
      autoplaySpeed: 3000,
      slidesToShow: slidesToShow,
      ...arrowSlider
    }
    
    if (data.length !== 0) {
      if(isMobile){
        return(
          <>
            <div className='palette-grid'>
              {data.map((item, itemIndex) => (
                <div key={itemIndex} className='palette-grid-item' style={{backgroundColor: item}}></div>
              ))}
            </div>
          </>
          )
      }else{
        return(
          <Slider key={JSON.stringify(data)} className='product-slider' {...settingsPaletteSlider}>
            {data.map((item, itemIndex) => (
              <div key={itemIndex} className='product-slide'>
                <div className='palette-grid-item' style={{backgroundColor: item}}></div>
              </div>
              ))}
          </Slider>
        )
      }
    }
  
    return null;
  };

  useEffect(() => {
    mobileAndTabletCheck();

    if(!location.state){
      navigate('/');
      return;
    }
  
    let name = location.state.name
    let email = location.state.email
    let phone = location.state.phone
    let sub_season = location.state.subseasonal
    let sub_season_accuracy = location.state.subseasonalAccuracy
    let sub_season_alt = location.state.subseasonalAlt
    let sub_season_accuracy_alt = location.state.subseasonalAccuracyAlt
    let skintone = location.state.skintone
    let tmpComplexion = location.state.complexionName.split(' ')[0]

    setSkintoneColor(skintone)
    // setComplexionCode(tmpComplexion)
    // setComplexionName(location.state.complexionName.substr(4,location.state.complexionName.length))
    // setComplexion(location.state.complexionName)
    setUserName(name)
    setUserEmail(email)
    setUserPhone(phone)
    setSubSeasonAccuracy(parseFloat(sub_season_accuracy).toFixed(0))
    setSubSeasonAlt(sub_season_alt)
    setSubSeasonAccuracyAlt(parseFloat(sub_season_accuracy_alt).toFixed(0))

    setComplexionCode(tmpComplexion)
    setComplexionName(location.state.complexionName.substr(4,location.state.complexionName.length))
    setComplexion(location.state.complexionName)
    // fetch(resultAPI)
    //   .then((response) => response.json())
    //   .then((jsonData) => {
        // console.log(jsonData)
        let complexionIndex =  jsonData.complexion.findIndex(object => (object.code === tmpComplexion)) || 0;
        // console.log(tmpComplexion)
        let resultData = {};
        setShareTemplate(sub_season);

        if (sub_season === 'COOL SUMMER') {
          resultData = jsonData.season[2];
          // setComplexionProducts(jsonData.complexion[0].item)
          setComplexionProducts((prev) => [
            ...prev,
            { code: jsonData.complexion[0].code, item: jsonData.complexion[0].item }
          ])
        } else if (sub_season === 'COOL WINTER') {
          resultData = jsonData.season[3];
          // setComplexionProducts(jsonData.complexion[8].item)
          setComplexionProducts((prev) => [
            ...prev,
            { code: jsonData.complexion[8].code, item: jsonData.complexion[8].item }
          ])
        } else if (sub_season === 'WARM SPRING') {
          resultData = jsonData.season[0];
          setComplexionProducts((prev) => [
            ...prev,
            { code: jsonData.complexion[2].code, item: jsonData.complexion[2].item },
            { code: jsonData.complexion[3].code, item: jsonData.complexion[3].item },
            { code: jsonData.complexion[5].code, item: jsonData.complexion[5].item },
          ]);
        } else if (sub_season === 'WARM AUTUMN') {
          resultData = jsonData.season[1];
          setComplexionProducts((prev) => [
            ...prev,
            { code: jsonData.complexion[4].code, item: jsonData.complexion[4].item },
            { code: jsonData.complexion[6].code, item: jsonData.complexion[6].item },
            { code: jsonData.complexion[7].code, item: jsonData.complexion[7].item },
          ]);
        }

        setSubSeason(sub_season);

        setResult(resultData);


        setShareComplexionProducts(jsonData.complexion[complexionIndex].share_products)

      // })
      // .catch((error) => console.error('Error fetching data:', error));
      sendAnalyticsData('View Page','Result Template Page')

      setTimeout(function() {
        var headerDom = document.querySelector('.header-container');
        setTimeout(function() {
          headerDom.classList.remove('open-hint');
        }, 5000)
      }, 0);
  }, []);

  const postPhotoURL = 'https://wardah-colourstory.com/vto-post';

  const manualPost = (path, params, method='post') => {

    // The rest of this code assumes you are not using a library.
    // It can be made less verbose if you use one.
    const form = document.createElement('form');
    form.method = method;
    form.action = path;
    form.enctype = 'multipart/form-data';
  
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        const hiddenField = document.createElement('input');
        hiddenField.type = 'hidden';
        hiddenField.name = key;
        hiddenField.value = params[key];
  
        form.appendChild(hiddenField);
      }
    }
  
    document.body.appendChild(form);
    form.submit();
  }
  const handleConvertToCanvas = () => {
    // html2canvas(divElement, {
    //   scale: 3,
    //   allowTaint: false,
    //   useCORS: true
    // }).then(async (canvas) => {
      // var data = canvas.toDataURL('image/jpeg'); // This is the base64 image
  
      // if (navigator.share) {
        // try {
          // await navigator.share({
          //   files: [new File([await (await fetch(data)).blob()], 'image.jpeg', { type: 'image/jpeg' })]
          // });
          
          sendAnalyticsData('Click', 'Share Button');
          // const postPhotoURL = 'https://localhost:3031/vto-post';
  
          // Ensure required fields are available before submitting
          if (
            location.state.photo,
            location.state.name &&
            location.state.email &&
            location.state.phone &&
            location.state.subseasonal &&
            location.state.subseasonalAccuracy &&
            location.state.subseasonalAlt &&
            location.state.subseasonalAccuracyAlt &&
            getShade()
          ) {
            manualPost(postPhotoURL, {
              "fullname": location.state.name,
              "email": location.state.email,
              "phone": location.state.phone,
              "season": location.state.subseasonal,
              "season_accuracy": parseFloat(location.state.subseasonalAccuracy).toFixed(0),
              "season_alt": location.state.subseasonalAlt,
              "season_alt_accuracy": parseFloat(location.state.subseasonalAccuracyAlt).toFixed(0),
              "complexion": getShade(),
              "photo": location.state.photo
            });
        //   }
        // } catch (error) {
        //   console.error('Error sharing:', error);
        // }
      }
    // });
  };
  
  const handleDownloadCanvas = () => {
    html2canvas(divElement, {
      "scale": 2
    }).then((canvas) => {
      var data = canvas.toDataURL('image/jpeg');
      const a = document.createElement('a');
      a.href = data;
      // a.target = '_blank';
      a.download = shareTemplate+'.jpeg';
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      sendAnalyticsData('Click','Download Button')
    });
  };

  const getShade = () => {
    var shadeCode = '';
  
    // SPRING
    if (subSeason === 'WARM SPRING' && subSeasonAccuracy >= 92){
      shadeCode = '#21W';
    }
  
    if (subSeason === 'WARM SPRING' && subSeasonAccuracy >= 93){
      shadeCode = '#22N';
    }
    
    if(subSeason === 'WARM SPRING' && subSeasonAccuracy === 91){
      shadeCode = '#23W';
    }
    
    if(subSeason === 'WARM SPRING' && subSeasonAccuracy <= 90){
      shadeCode = '#32N';
    }
  
    // AUTUMN
    if(subSeason === 'WARM AUTUMN' && subSeasonAccuracy < 91){
      shadeCode = '#31W';
    }
    
    if(subSeason === 'WARM AUTUMN' && subSeasonAccuracy <= 93 && subSeasonAccuracy >= 91){
      shadeCode = '#33W';
    }
    
    if(subSeason === 'WARM AUTUMN' && subSeasonAccuracy >= 94){
      shadeCode = '#34W';
    }
    
    if(subSeason === 'WARM AUTUMN' && subSeasonAccuracy >= 95){
      shadeCode = '#42N';
    }
    
    if(subSeason === 'WARM AUTUMN' && subSeasonAccuracy >= 96){
      shadeCode = '#41W';
    }
    
    if(subSeason === 'WARM AUTUMN' && subSeasonAccuracy >= 97){
      shadeCode = '#43W';
    }
  
    // SUMMER
    if(subSeason === 'COOL WINTER'){
      shadeCode = '';
    }
  
    if(subSeason === 'COOL SUMMER' && subSeasonAccuracy >= 93){
      shadeCode = '#22C';
    }
    
    if(subSeason === 'COOL SUMMER' && subSeasonAccuracy >= 94){
      shadeCode = '#21C';
    }
  
    if(subSeason === 'COOL SUMMER' && subSeasonAccuracy >= 95){
      shadeCode = '#11C';
    }
  
    if(subSeason === 'COOL SUMMER' && subSeasonAccuracy >= 91 && subSeasonAccuracy <= 92){
      shadeCode = '#31C';
    }
  
    if(subSeason === 'COOL SUMMER' && subSeasonAccuracy <= 90){
      shadeCode = '#32C';
    }
    
    return (shadeCode);
  };

  return (
    <>
      <div ref={captureMobileRef} className='result-container result-container-mobile d-block d-lg-none'>
        {console.log(location.state)}
        <div className="header-container open-hint">
          <div className='header-inner d-flex justify-content-end'  style={{backgroundImage: `url(${result.headerBG})`}}>
            {/* <img className="personal" src="/images/personal.png" /> */}
            <div className="logo-container w-50 d-flex flex-column align-items-end justify-content-start">
              <img src="/images/logo-template.png" />
              <div className="my-0 me-0">
                <div className="wardah-text header-your-name mb-2">{userName}</div>
                {/* <div className="w-100 bg-white" style={{height: '1px'}} /> */}
              </div>
            </div>
            <div className='header-percentage'>
              <div className='percentage-value value-1'>
                <div className='percentage-number'>
                  {parseInt(subSeasonAccuracy)+'%'}
                </div>
                <div className='percentage-name'>{subSeason}</div>
              </div>
              <div className='percentage-value value-2'>
                <div className='percentage-number'>
                {parseInt(subSeasonAccuracyAlt)+'%'}
                </div>
                <div className='percentage-name'>{subSeasonAlt}</div>
              </div>
            </div>
          </div>
        </div>
        <div className='d-block d-lg-flex d-sm-flex justify-content-center'>
          <div className='column-palette-wrapper d-block d-lg-flex flex-column vw-100 flex-grow-1 justify-content-end'>
            <div className="palette-container d-lg-flex align-items-start">
              {/* <div className="section-title d-table mt-4" style={{minWidth: '146px'}}>COLOR PALETTES</div> */}
              <div className='palette-grid-wrapper'>
                <RenderPaletteGrid data={result.palette} slidesToShow={5} isMobile={true}/>
              </div>
            </div>
            <div className="complexion-container vw-100 d-flex justify-end align-items-center flex-column">
              {/* <p className="text-tryon-notif text-center mt-0">Click the products for Virtual  Try-On!</p> */}
              {
                complexionProducts ? 
                  complexionProducts.map((complexionEl, index) => {
                    if(index === 0){
                      return (
                        <>
                          <div className='d-flex align-items-center gap-1 gap-md-2 w-100 ps-2'>
                            <div className="section-title-container flex-grow-1">
                              <img src="/images/title-complexion.png" />
                            </div>
                            <div className='section-palette-container d-flex align-items-center me-0 me-md-3 mt-1'>
                              <div className='d-flex align-items-center justify-content-end gap-1 gap-md-2 '>
                                <div className="palette" style={{backgroundColor: skintoneColor}}></div>
                                <div className="wardah-text">{getShade()}</div>
                              </div>
                            </div>
                          </div>
                          <div className='complexion-products-slider mt-4 mb-3' style={{ maxWidth: 'unset', width: 'auto' }}>
                            {/* <RenderProductComplexion data={complexionProducts} slidesToShow={3}/> */}
                            <RenderProductComplexionMobile data={complexionEl.item} />
                          </div>
                          
                          <div className='d-flex align-items-center gap-1 gap-md-2 w-100 ps-2'>
                            <div className="section-title-container flex-grow-1">
                              <img style={{ maxWidth: '49.5%' }} src="/images/complexion-lightening-title.png" alt="Complexion Title" />
                            </div>
                          </div>
                          
                          <div className='complexion-products-slider mt-4' style={{ maxWidth: 'unset', width: 'auto' }}>
                            <RenderProductComplexionLightening data={complexionEl.item} />
                          </div>
                        </>
                      );
                    }
                  })
                : null
              }
              
            </div>
          </div>
          {/* <div className="ecommerce-container px-3 d-none d-lg-flex flex-column align-items-center justify-content-center text-center">
            <img width='140' src='/images/title-get-yours.png' className='mb-3' alt=''/>
            <p>
              <a id='shop-btn' className='btn' href='#' target='_blank'>Shop Now</a>
            </p>
          </div> */}
        </div>
        <div className='d-block d-lg-flex flex-wrap'>
          <div className="category-product-section wardah-box-md lips-section position-relative">
            <div className="lips-title wardah-text text-white d-block d-lg-none text-center">MAKEUP THAT SUITS YOU BEST</div>
              <div className="section-title-container d-table mt-4 mb-5 mx-auto" style={{width: '27%'}}>
                <img src="/images/lip-title.png" />
            </div>
            <RenderProductsLipsMobile data={result.lips} />
          </div>
          <div className="category-product-section wardah-box-md eyes-section wardah-bg-light py-3">
            <div className="section-title-container mt-5 mb-3 d-table mx-auto" style={{width: '20%'}}>
              <img src="/images/eye-title.png" />
            </div>
              <RenderProductsEyes data={result.eyes} isMobile={true}/>
          </div>
          <div className="category-product-section blushon-section mb-4">
            <div className="section-title-container d-table mt-5 mb-4 mx-auto" style={{width: '28%'}}>
              <img src="/images/blush-title.png" />
            </div>
              <RenderProductsBlushOn data={result.blushOn} />
          </div>
          <div className="ecommerce-container mt-4 pt-3 pb-3 px-2 d-block d-lg-none text-center">
            <img width='140' src='/images/title-get-yours.png' className='mb-3' alt=''/>
            <p>
              <a id='shop-btn-desktop' className='btn d-none d-lg-table' href='https://www.wardahbeauty.com/id/product/list/make-up' onClick={()=>{sendAnalyticsData('Click',`https://www.wardahbeauty.com/id/product/list/make-up`)}} target='_blank'>SHOP NOW</a>
            </p>
          </div>
        </div>
        <div className="ecommerce-container d-block d-lg-none">
          <div className="ecommerce-title wardah-text text-white">SHOP YOUR BEAUTY MATCH!</div>
          <div className="ecommerce-button-container mx-auto my-0">
            <a href="https://www.wardahbeauty.com/id/product/list/sale/sort/makeup" className="ecommerce-button wardah" onClick={()=>{sendAnalyticsData('Click',`Wardah Website`)}} ><img className="w-100 h-100" src="/images/wardah.png" /></a>
            <a href="https://shopee.co.id/wardahofficial?categoryId=100630&entryPoint=ShopByPDP&itemId=3010539954" onClick={()=>{sendAnalyticsData('Click',`Shopee Website`)}}  className="ecommerce-button shopee"><img className="w-100 h-100" src="/images/shopee.png" /></a>
            {/* <a href="http://www.tiktok.com/" className="ecommerce-button tiktok" target='_blank'><img className="w-100 h-100" src="/images/tiktok.png" /></a> */}
            <a href="https://www.lazada.co.id/shop/wardah-ofc-store/?itemId=4640860337&spm=a2o4j.pdp_revamp.seller.1.44693987x1jJwM&path=promotion-39695-0.htm&tab=promotion&channelSource=pdp" onClick={()=>{sendAnalyticsData('Click',`Lazada Website`)}}  className="ecommerce-button lazada"><img className="w-100 h-100" src="/images/lazada.png" /></a>
            <a href="https://www.tokopedia.com/wardah-official" className="ecommerce-button tokopedia" onClick={()=>{sendAnalyticsData('Click',`Tokopedia Website`)}} ><img className="w-100 h-100" src="/images/tokped.png" /></a>
          </div>
        </div>
        <div className='d-flex justify-content-center gap-4 mt-2 mb-4'>
          <a href='/' className='result-action btn'>FINISH</a>
          <button id="share-btn" className='result-action btn' onClick={handleConvertToCanvas}>SHARE</button>
        </div>
        <img className='powered-logo' src='/images/pixielab.png'/>
      </div>
      
      <div className='result-container result-container-desktop d-none d-lg-block'>
        <div className='result-wrapper d-block d-lg-flex d-sm-flex justify-content-between flex-wrap'>
          <div className='d-block d-lg-block section-result-left'>
            <div className='d-block d-lg-flex d-sm-flex justify-content-center'>
        <div className="header-container mb-3">
          <div className='header-inner d-flex justify-content-end'  style={{backgroundImage: `url(${result.headerBG})`}}>
            {/* <img className="personal" src="/images/personal.png" /> */}
            <div className="logo-container w-50 d-flex flex-column align-items-end justify-content-start">
              <img src="/images/logo-template.png" />
              <div className="my-0 me-0">
                <div className="wardah-text header-your-name mb-2">{userName}</div>
                {/* <div className="w-100 bg-white" style={{height: '1px'}} /> */}
              </div>
            </div>
            <div className='header-percentage'>
              <div className='percentage-value value-1'>
                <div className='percentage-number'>
                  {parseInt(subSeasonAccuracy)+'%'}
                </div>
                <div className='percentage-name'>{subSeason}</div>
              </div>
              <div className='percentage-value value-2'>
                <div className='percentage-number'>
                {parseInt(subSeasonAccuracyAlt)+'%'}
                </div>
                <div className='percentage-name'>{subSeasonAlt}</div>
              </div>
            </div>
          </div>
        </div>
              <div className="complexion-container w-100 d-flex flex-column px-2">
                <div className="section-title-container flex-grow-1 w-100">
                  <img style={{minWidth: '170px'}} src="/images/title-complexion.png" />
                </div>
                <div className='section-palette-container d-flex align-items-center gap-2 gap-lg-3'>
                  <div className='skintone-name'>
                    <div className='skintone-code'>
                      <div className="palette" style={{backgroundColor: skintoneColor}}></div>
                      <span>{getShade()}</span>
                    </div>
                    {/* {complexionName.toUpperCase()} */}
                  </div>
                  <div className='complexion-products-slider'>
                    {complexionProducts ?
                      <RenderProductComplexion data={complexionProducts} slidesToShow={1}/>
                      :
                      null
                    }
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="ecommerce-container px-3 d-none d-lg-flex flex-column align-items-center justify-content-center text-center">
              <img width='140' src='/images/title-get-yours.png' className='mb-3' alt=''/>
              <p>
                <a id='shop-btn' className='btn' href='#' target='_blank'>Shop Now</a>
              </p>
            </div> */}
            <div className="lips-section position-relative d-flex">
              <div className="lips-title wardah-text text-white d-block d-lg-none text-center">MAKEUP THAT SUITS YOU BEST</div>
              <div className="section-title-container d-table d-lg-none my-4 mx-auto">
                <img src="/images/lip-title.png" />
              </div>

              <div className='d-none d-lg-flex justify-content-center align-items-center section-title-desktop'>
                <img src="/images/section-title-lips.png" />
              </div>
              <div className='list-product-lips'>
                <RenderProductsLips data={result.lips} />
              </div>
            </div>
          </div>
          <div className='d-block d-md-block section-result-right'>
            <p class="text-tryon-notif text-center mt-4 mb-0">Click the products for Virtual Try-On!</p>
            <div className="palette-container align-items-end justify-content-center flex-column d-none">
              <div className="section-title d-table mx-auto" style={{minWidth: '140px'}}>COLOR PALETTES</div>
              <div className='palette-grid-wrapper right-side-board px-0 mt-3'>
                <div className="palette-grid mt-md-1">
                  <RenderPaletteGrid data={result.palette} slidesToShow={10}/>
                </div>
              </div>
            </div>
            <div className="category-product-section eyes-section d-md-flex justify-content-between align-items-center right-side-board pb-1 mt-5" style={{borderRadius: '80px 0 0 80px'}}>
              <div className="section-title-container" style={{width: '20%'}}>
                <img src="/images/eye-title.png" />
              </div>
              <div className='eyes-slider-wrapper'>
                <RenderProductsEyes data={result.eyes} />
              </div>
            </div>
            <div className="category-product-section blushon-section d-lg-flex justify-content-between align-items-center right-side-board" style={{borderRadius: '80px 0 0 80px'}}>
              <div className="section-title-container" style={{width: '27%'}}>
                <img src="/images/blush-title.png" />
              </div>
              <div className='blushon-slider-wrapper'>
                <RenderProductsBlushOn data={result.blushOn} />
              </div>
            </div>
            <div className="ecommerce-container pb-2 px-2 mt-xl-5 d-none d-lg-flex text-center align-items-center w-100">
              <img src='/images/title-get-yours.png' className='get-yours-image ms-2 me-2' alt=''/>
              {/* <a id='shop-btn' className='btn me-2' href='https://www.wardahbeauty.com/id/product/list/make-up' target='_blank'>SHOP NOW</a> */}

              <div className="ecommerce-button-container ecommerce-container-desktop mx-auto gap-1 gap-md-2 py-0 ms-0">
                <a href="https://www.wardahbeauty.com/id/product/list/sale/sort/makeup" onClick={()=>{sendAnalyticsData('Click',`Wardah Website`)}} className="ecommerce-button wardah"><img className="w-100 h-100" src="/images/wardah.png" /></a>
                <a href="https://shopee.co.id/wardahofficial?categoryId=100630&entryPoint=ShopByPDP&itemId=3010539954" onClick={()=>{sendAnalyticsData('Click',`Shopee Website`)}} className="ecommerce-button shopee"><img className="w-100 h-100" src="/images/shopee.png" /></a>
                {/* <a href="http://www.tiktok.com/" className="ecommerce-button tiktok"><img className="w-100 h-100" src="/images/tiktok.png" /></a> */}
                <a href="https://www.lazada.co.id/shop/wardah-ofc-store/?itemId=4640860337&spm=a2o4j.pdp_revamp.seller.1.44693987x1jJwM&path=promotion-39695-0.htm&tab=promotion&channelSource=pdp" onClick={()=>{sendAnalyticsData('Click',`Lazada Website`)}} className="ecommerce-button lazada"><img className="w-100 h-100" src="/images/lazada.png" /></a>
                <a href="https://www.tokopedia.com/wardah-official" onClick={()=>{sendAnalyticsData('Click',`Tokopedia Website`)}} className="ecommerce-button tokopedia"><img className="w-100 h-100" src="/images/tokped.png" /></a>
              </div>
              {deviceType && deviceType === 'desktop' ?
                <a id="download-btn-desktop" className='d-flex align-items-center ms-auto' onClick={handleDownloadCanvas}>
                  DOWNLOAD
                  <span>
                    <CgSoftwareDownload/>
                  </span>
                </a>
                :  
                <button id="share-btn" className='result-action btn my-0' onClick={handleConvertToCanvas}>SHARE</button>
              }
            </div>
          </div>
            
          <div className='w-100 d-flex align-items-center justify-content-center mt-2'>
            <a href='/' className='result-action btn' style={{'width': '164px'}}>FINISH</a>
          </div>
        </div>
      </div>
      
      <div className='share-template-wrapper position-fixed' style={{zIndex: '-1', aspectRatio: '9/16', width: '430px', height: '920px'}}>
        <div className='share-template position-relative'>
          <img className='w-100' src={`/images/share-templates/${shareTemplate}.jpg`} alt=''/>
          
          <p className='share-template-username'>{userName}</p>
          <img className='share-complexion-product' src={`/images/share-templates/${shareComplexionProducts}`} alt=''/>
        </div>
      </div>
      <div ref={canvasRef}></div>
    </>
  );
};

export default PageResultTemplate;
